import {InputError} from '../components/AdminMeetingCommentInputForm'
import {Nullable} from '../../../app/TypeHelpers'
import {SubmitCommentAndFilesTemplate} from './SubmitCommentAndFilesTemplate'
import {AsyncCallFunctionType, AsyncFunction} from '../../shared/hoc/withAsyncCommunication'
import {HttpError} from '../../../network/errors/HttpError'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import {FileDataForValidate} from './FileDataForValidate'

export abstract class SubmitCommentAndFilesTemplateForAdmin<S> extends SubmitCommentAndFilesTemplate<S> {
    asyncCallFunction: AsyncCallFunctionType
    eventEmitterExAdmin: EventEmitterExAdmin

    protected constructor(
        registerCommentError: (inputError: InputError) => void,
        asyncCallFunction: AsyncCallFunctionType,
        eventEmitter: EventEmitterExAdmin,
    ) {
        super(registerCommentError, eventEmitter)
        this.asyncCallFunction = asyncCallFunction
        this.eventEmitterExAdmin = eventEmitter
    }

    abstract registerCommentFunction(sendData: S): AsyncFunction<any, number>

    abstract validateFileFunction(fileDataForValidate: FileDataForValidate): AsyncFunction<any, void>

    async registerComment(sendData: S): Promise<Nullable<number>> {
        return await this.asyncCallFunction(
            this.registerCommentFunction(sendData),
            (e) => {
                if (e instanceof HttpError) {
                    const inputError = {
                        title: 'コメントを登録できませんでした。',
                        messages: this.getErrorMessages(e.responseBody),
                    }
                    this.registerCommentError(inputError)
                } else {
                    e.broadcast(this.eventEmitterExAdmin)
                }
            },
        )
    }

    async validateFile(fileDataForValidate: FileDataForValidate): Promise<Nullable<void>> {
        return await this.asyncCallFunction(
            this.validateFileFunction(fileDataForValidate),
            (e) => {
                if (e instanceof HttpError) {
                    const inputError = {
                        title: 'コメントを登録できませんでした。',
                        messages: ['ファイル名に機種依存文字が使用されています。', 'ファイル名を変更し、資料の追加をやり直してください。'],
                        fileNameList: this.getErrorFileNames(e.responseBody, fileDataForValidate),
                    }
                    this.registerCommentError(inputError)
                } else {
                    e.broadcast(this.eventEmitterExAdmin)
                }
            },
        )
    }
}
